import type { ReactElement } from 'react'
import { useTheme } from '@mui/material'
import { ThreeEvent } from '@react-three/fiber'
import MemberMeshElement from 'src/components/scene/MemberMeshElement'

export type SceneCrossSectionElement = {
  id: string
  start: Point
  end: Point
  coordinateSystem: CoordinateSystem
  height: number
  width: number
  crossSection: CrossSectionTimberOrCLTOrSteel
  elementType?: ElementTypes | PositionForVertical['element_type']
  color?: string
  outlinesColor?: string
}

type SceneCrossSectionsProps = {
  elements: SceneCrossSectionElement[]
  onClick?: (event: ThreeEvent<MouseEvent>) => void
}

const getCrossSectionShape = (
  crossSection: CrossSectionTimberOrCLTOrSteel,
): SteelCSShape | RectangularCSShape | undefined => {
  if (!('shape' in crossSection)) return undefined
  return crossSection.shape
}

const SceneCrossSections = ({ elements, onClick }: SceneCrossSectionsProps): ReactElement => {
  const theme = useTheme()

  return (
    <group>
      {elements.map(element => (
        <MemberMeshElement
          key={element.id}
          name={element.id}
          start={element.start}
          end={element.end}
          coordinateSystem={element.coordinateSystem}
          onClick={onClick}
          cursor={onClick ? 'pointer' : undefined}
          userData={{
            guid: element.id,
            elementType: element.elementType,
          }}
          color={
            element.color ||
            (element.crossSection.kind === 'Steel'
              ? theme.scenePalette.elements3d.steelBeams
              : theme.scenePalette.elements3d.columns)
          }
          outlinesColor={element.outlinesColor || theme.scenePalette.outlines}
          lineWidth={1}
          height={element.height}
          width={element.width}
          outlines
          crossSectionShape={getCrossSectionShape(element.crossSection)}
        />
      ))}
    </group>
  )
}

export default SceneCrossSections
